"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessageDtoContentFromJSON = ChatMessageDtoContentFromJSON;
exports.ChatMessageDtoContentFromJSONTyped = ChatMessageDtoContentFromJSONTyped;
exports.ChatMessageDtoContentToJSON = ChatMessageDtoContentToJSON;
exports.ChatMessageDtoContentToJSONTyped = ChatMessageDtoContentToJSONTyped;
function ChatMessageDtoContentFromJSON(json) {
    return ChatMessageDtoContentFromJSONTyped(json, false);
}
function ChatMessageDtoContentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfArray(json)) {
        return Array < ContentBlockDto > FromJSONTyped(json, true);
    }
    if (instanceOfstring(json)) {
        return stringFromJSONTyped(json, true);
    }
    return {};
}
function ChatMessageDtoContentToJSON(json) {
    return ChatMessageDtoContentToJSONTyped(json, false);
}
function ChatMessageDtoContentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfArray(value)) {
        return Array < ContentBlockDto > ToJSON(value);
    }
    if (instanceOfstring(value)) {
        return stringToJSON(value);
    }
    return {};
}
//# sourceMappingURL=ChatMessageDtoContent.js.map